import { useEffect, useMemo, useState } from "react";
import api from "../../../services/api";
import { FaUsers, FaSearch, FaUser } from "react-icons/fa";

function CustomersAdmin() {
  const [customers, setCustomers] = useState([]);
  const [search, setSearch] = useState("");

  useEffect(() => {
    api
      .get("/admin/customers", {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((res) => setCustomers(res.data))
      .catch(console.error);
  }, []);

  const filteredCustomers = useMemo(() => {
    const query = search.trim().toLowerCase();
    if (!query) return customers;

    return customers.filter((customer) =>
      [
        customer.user_id,
        customer.first_name,
        customer.last_name,
        customer.email,
        customer.phone,
        customer.city,
      ].some((value) => String(value || "").toLowerCase().includes(query)),
    );
  }, [customers, search]);

  const withCity = customers.filter((customer) => customer.city).length;

  return (
    <section className="dashboard-section customers-section">
      <div className="section-title">
        <div className="section-title-main">
          <span className="section-icon"><FaUsers /></span>
          <div>
            <h2>לקוחות</h2>
            <p>פרטי הלקוחות הרשומים במערכת</p>
          </div>
        </div>
        <span className="section-count">{customers.length} לקוחות</span>
      </div>

      <div className="admin-mini-stats customer-mini-stats">
        <div><strong>{customers.length}</strong><span>לקוחות רשומים</span></div>
        <div><strong>{withCity}</strong><span>עם עיר מעודכנת</span></div>
      </div>

      <div className="entity-toolbar">
        <div className="orders-search compact-search">
          <FaSearch />
          <input
            type="text"
            value={search}
            onChange={(event) => setSearch(event.target.value)}
            placeholder="חיפוש לפי שם, טלפון, אימייל או עיר..."
            aria-label="חיפוש לקוחות"
          />
        </div>
        <span className="entity-result-label">מציג {filteredCustomers.length} תוצאות</span>
      </div>

      <div className="admin-table-wrap">
        <table>
          <thead>
            <tr>
              <th>לקוח</th>
              <th>אימייל</th>
              <th>טלפון</th>
              <th>עיר</th>
              <th>תאריך הצטרפות</th>
            </tr>
          </thead>

          <tbody>
            {filteredCustomers.length === 0 ? (
              <tr><td colSpan="5" className="empty-table-cell">אין לקוחות להצגה</td></tr>
            ) : (
              filteredCustomers.map((customer) => (
                <tr key={customer.user_id}>
                  <td>
                    <div className="customer-name-cell">
                      <span className="customer-avatar"><FaUser /></span>
                      <div>
                        <strong>{customer.first_name} {customer.last_name}</strong>
                        <small>לקוח #{customer.user_id}</small>
                      </div>
                    </div>
                  </td>
                  <td>{customer.email}</td>
                  <td>{customer.phone}</td>
                  <td>{customer.city || "-"}</td>
                  <td>{new Date(customer.created_at).toLocaleDateString("he-IL")}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </section>
  );
}

export default CustomersAdmin;
